import React from "react";

export default function GalleryNav({ onPrev, onNext }) {
  return (
    <>
      <button
        type="button"
        className="gallery-nav-zone gallery-nav-zone--left"
        aria-label="Предыдущее изображение"
        onClick={onPrev}
        data-testid="gallery-nav-left"
      >
        <span className="gallery-nav-arrow" aria-hidden="true">
          ‹
        </span>
      </button>
      <button
        type="button"
        className="gallery-nav-zone gallery-nav-zone--right"
        aria-label="Следующее изображение"
        onClick={onNext}
        data-testid="gallery-nav-right"
      >
        <span className="gallery-nav-arrow" aria-hidden="true">
          ›
        </span>
      </button>
    </>
  );
}
